import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.hideAlert)
      ? (_openBlock(), _createBlock(_component_AlertError2, {
          key: 0,
          error: _ctx.componentUI.getError()
        }, null, 8, ["error"]))
      : _createCommentVNode("", true),
    (!_ctx.componentUI.isReady())
      ? (_openBlock(), _createBlock(_component_base_spinner, { key: 1 }))
      : _renderSlot(_ctx.$slots, "default", { key: 2 })
  ]))
}